import UNIQUE from '@/common/unique'

export default {
  id: 'widget',
  name: 'widget',
  type: 'standard',
  moduleName: 'editor_module_widget',
  hide: true,
  dataSet: {
    mods: 'widget',
    column: []
  },
  setting: {
    layout: {
      options: []
    },
    action: null,
    detail: null
  }
}
